import { useEffect, useState } from "react";
import ad1 from "../../images/ads/ad_1.jpg";
import ad2 from "../../images/ads/ad_2.jpg";
import ad3 from "../../images/ads/ad_3.jpg";
import ad4 from "../../images/ads/ad_4.jpg";

const AD_IMAGES = [
  { src: ad1, alt: "Advertisement 1" },
  { src: ad2, alt: "Advertisement 2" },
  { src: ad3, alt: "Advertisement 3" },
  { src: ad4, alt: "Advertisement 4" }
];

const ROTATE_MS = 30000;

function AdsBanner() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % AD_IMAGES.length);
    }, ROTATE_MS);

    return () => window.clearInterval(timer);
  }, []);

  return <section className="vd-ads-banner" aria-label="Advertisements" aria-live="polite">
      {AD_IMAGES.map((ad, index) => <img
        key={ad.src}
        src={ad.src}
        alt={ad.alt}
        className={`vd-ads-banner-image${index === activeIndex ? " is-active" : ""}`}
        loading={index === 0 ? "eager" : "lazy"}
      />)}
    </section>;
}

export default AdsBanner;
